import { z } from "zod";

export const SocialAnalysePromptDocumentSchema = z
  .object({
    protocolVersion: z.literal("social-evidence-v1"),
    persona: z.string().min(1),
    evidenceRules: z.string().min(1),
    steps: z.array(z.string().min(1)).min(1),
  })
  .strict();
export type SocialAnalysePromptDocument = z.infer<
  typeof SocialAnalysePromptDocumentSchema
>;
